export default function MinutaHtml({ datos, infoMinuta }) {
    return (
        <div style={{
            maxWidth: 900,
            margin: "auto",
            fontFamily: "Helvetica,Arial,sans-serif",
            fontSize: 11
        }}>
            <h3 style={{
                textAlign: "center",
                fontWeight: "normal"
            }}>
                {(infoMinuta.find(x => x.str_nombrecampo === 'titulo1') || {}).str_descripcion || "FALTA CONFIGURACION TITULO MINUTA"}
            </h3>
            <div style={{
                textAlign: "center",
                marginBottom: 10
            }}>
                {(infoMinuta.find(x => x.str_nombrecampo === 'contratos') || {}).str_descripcion || "FALTA CONFIGURACION CONTRATOS MINUTA"}
            </div>
            <div style={{ marginBottom: 10 }}>
                <b>{(infoMinuta.find(x => x.str_nombrecampo === 'acepto') || {}).str_descripcion || "FALTA ACEPTACION MINUTA"}</b>
            </div>
            <ul style={{ marginBottom: 15 }}>
                <li>Los productos recibidos son de primera calidad con auditoria permanente de la Unidad de Seguridad Alimentaria – Secretaría de Inclusión Social y Familia.</li>
                <li>El valor de los productos se asignan según la tipología del núcleo familias así: A, B, C y D.</li>
                <li>Los productos cumplen con requisitos de seguridad, fechas de vencimiento y certificados de salud.</li>
                <li>Los productos han sido empacados de acuerdo a la minuta establecida para un periodo de un mes.</li>
                <li>No recibiré apoyo económico adicional para el empaque o traslado de los productos recibidos.</li>
                <li>La firma del acta conforma el recibido por parte del (los/las) beneficiarios(as) de las siguientes minutas:</li>
            </ul>

            <table border="1" cellPadding="4" cellSpacing="0" style={{
                width: "100%",
                marginBottom: 15,
                fontSize: 12
            }}>
                <thead style={{ background: "#e0e0e0" }}>
                    <tr>
                        <th>GRUPO DE ALIMENTOS</th>
                        <th>ALIMENTOS</th>
                        <th>UNIDAD DE MEDIDA</th>
                        <th>CANTIDAD POR PAQUETE</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Productos azucarados</td><td>Panela en bloque</td><td>Mínimo 900 grs</td><td>1</td></tr>
                    <tr><td>Bebidas</td><td>Cocoa en polvo</td><td>Paquete mínimo 250 grs</td><td>1</td></tr>
                    <tr><td>Pescados y Mariscos</td><td>Atún en aceite</td><td>Latas de 170 grs o superior</td><td>4</td></tr>
                    <tr><td>Huevos y derivados</td><td>Huevo tipo A</td><td>Unidad tipo A</td><td>30</td></tr>
                    <tr><td>Cereales y Derivados</td><td>Arroz blanco tipo 1 fortificado</td><td>Libra</td><td>6</td></tr>
                    <tr><td>Cereales y Derivados</td><td>Harina para arepas</td><td>Libra</td><td>1</td></tr>
                    <tr><td>Cereales y Derivados</td><td>Galletas tipo soda</td><td>Paquete 300 grs</td><td>1</td></tr>
                    <tr><td>Cereales y Derivados</td><td>Pasta menuda para sopa</td><td>Paquete 250 grs</td><td>1</td></tr>
                    <tr><td>Cereales y Derivados</td><td>Espaguetis</td><td>Paquete 250 grs</td><td>1</td></tr>
                    <tr><td>Cereales y Derivados</td><td>Avena en hojuelas</td><td>Paquete 250 grs</td><td>1</td></tr>
                    <tr><td>Grasas y Aceites</td><td>Aceite vegetal</td><td>Litro (1.000cc)</td><td>1</td></tr>
                    <tr><td>Leches y Derivados</td><td>Leche entera en Polvo</td><td>Bolsa desde 380 grs o superior</td><td>1</td></tr>
                    <tr><td>Leguminosas y Derivados</td><td>Frijol cargamento de primera</td><td>Libra</td><td>3</td></tr>
                    <tr><td>Leguminosas y Derivados</td><td>Lenteja</td><td>Libra</td><td>1</td></tr>
                    <tr><td>Leguminosas y Derivados</td><td>Garbanzo</td><td>Libra</td><td>1</td></tr>
                    <tr><td>Misceláneos</td><td>Sal con Yodo</td><td>Libra</td><td>1</td></tr>
                </tbody>
            </table>

            <h4 style={{ marginBottom: 5 }}>KIT HABITAT</h4>
            <table border="1" cellPadding="4" cellSpacing="0" style={{
                width: "100%",
                marginBottom: 15,
                fontSize: 12
            }}>
                <thead style={{ background: "#e0e0e0" }}>
                    <tr>
                        <th>PRODUCTO (KIT HABITAT)</th>
                        <th>TIPO A</th>
                        <th>TIPO B</th>
                        <th>TIPO C</th>
                        <th>TIPO D</th>
                        <th>MEDIDA</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Colchoneta</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Cobija</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Almohada</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Toalla</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Sábana</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                </tbody>
            </table>

            <h4 style={{ marginBottom: 5 }}>KIT COCINA</h4>
            <table border="1" cellPadding="4" cellSpacing="0" style={{
                width: "100%",
                marginBottom: 15,
                fontSize: 12
            }}>
                <thead style={{ background: "#e0e0e0" }}>
                    <tr>
                        <th>PRODUCTO (KIT COCINA)</th>
                        <th>TIPO A</th>
                        <th>TIPO B</th>
                        <th>TIPO C</th>
                        <th>TIPO D</th>
                        <th>MEDIDA</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Chocolatera</td><td>1</td><td>1</td><td>1</td><td>2</td><td>Unid</td></tr>
                    <tr><td>Olla #24</td><td>1</td><td>1</td><td>1</td><td>2</td><td>Unid</td></tr>
                    <tr><td>Cucharon</td><td>1</td><td>1</td><td>1</td><td>2</td><td>Unid</td></tr>
                    <tr><td>Plato hondo</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Cuchara de mesa</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Taza</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Cuchillo de mesa</td><td>1</td><td>2</td><td>3</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Molino</td><td>1</td><td>1</td><td>1</td><td>1</td><td>Unid</td></tr>
                </tbody>
            </table>

            <h4 style={{ marginBottom: 5 }}>KIT ASEO</h4>
            <table border="1" cellPadding="4" cellSpacing="0" style={{
                width: "100%",
                marginBottom: 15,
                fontSize: 12
            }}>
                <thead style={{ background: "#e0e0e0" }}>
                    <tr>
                        <th>PRODUCTO (KIT ASEO)</th>
                        <th>TIPO A</th>
                        <th>TIPO B</th>
                        <th>TIPO C</th>
                        <th>TIPO D</th>
                        <th>MEDIDA</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Papel higiénico</td><td>2</td><td>3</td><td>4</td><td>5</td><td>Unid</td></tr>
                    <tr><td>Máquina de afeitar</td><td>1</td><td>1</td><td>1</td><td>1</td><td>Unid</td></tr>
                    <tr><td>Jabón de baño</td><td>1</td><td>2</td><td>3</td><td>4</td><td>125 Gr</td></tr>
                    <tr><td>Jabón de panela</td><td>1</td><td>1</td><td>1</td><td>1</td><td>250 Gr</td></tr>
                    <tr><td>Jabón en polvo</td><td>1</td><td>1</td><td>1</td><td>1</td><td>250 Gr</td></tr>
                    <tr><td>Cepillo de dientes</td><td>1</td><td>1</td><td>1</td><td>1</td><td>Unid</td></tr>
                    <tr><td>Crema dental</td><td>1</td><td>1</td><td>1</td><td>1</td><td>90 Gr</td></tr>
                    <tr><td>Paquete de toallas higiénicas</td><td>1</td><td>1</td><td>1</td><td>1</td><td>Pqte</td></tr>
                    <tr><td>Jabón de panela (doble propósito)</td><td>1</td><td>1</td><td>1</td><td>1</td><td>250 Gr</td></tr>
                    <tr><td>Jabón en polvo (doble propósito)</td><td>1</td><td>1</td><td>1</td><td>1</td><td>250 Gr</td></tr>
                    <tr><td>Estropajo</td><td>1</td><td>1</td><td>1</td><td>1</td><td>Unid</td></tr>
                    <tr><td>Plástica lava loza en polvo</td><td>1</td><td>1</td><td>1</td><td>1</td><td>250 Gr</td></tr>
                    <tr><td>Cepillo de uñas</td><td>1</td><td>1</td><td>1</td><td>1</td><td>Unid</td></tr>
                    <tr><td>Detergente en polvo</td><td>1</td><td>2</td><td>5</td><td>7</td><td>250 Gr</td></tr>
                </tbody>
            </table>

            <div style={{ marginBottom: 10 }}>
                <b>Opciones de recibido:</b>
                <ul>
                    <li>( ) Recibo a satisfacción la asistencia humanitaria compuesta por el paquete alimentario y/o kits después de revisar los paquetes.</li>
                    <li>(X) Recibo a satisfacción la asistencia humanitaria compuesta por el paquete alimentario y/o kits sin revisar los paquetes.</li>
                    <li>( ) No recibo la asistencia humanitaria compuesta por el paquete alimentario y/o kits.</li>
                </ul>
            </div>
        </div>
    );
}